<template>
  <section>
    <div class="botones-pagina">
      <router-link :to="{name: 'formularios'}" class="boton boton--volver"/>
      <button
        type="button"
        class="boton boton--cancelar"
        v-if="copia._id && editando"
        @click="cancelar"/>
      <button
        type="button"
        class="boton boton--editar"
        v-if="copia._id && !editando && copia.estado === 'rechazado'"
        @click="editar(copia)"/>
      <button
        ref="botonSiguiente"
        type="button"
        v-if="!copia._id && tabActual !== 9"
        class="boton boton--rojo"
        @click="siguiente(copia, tabActual)">
        <i class="fas fa-fw fa-arrow-alt-right"/>
        <span>Guardar y seguir</span>
      </button>
      <button
        type="button"
        v-if="!copia._id && tabActual === 9"
        class="boton boton--enviar"
        @click="$refs.bloque10.enviar(copia, $router.currentRoute.params.index)"/>
      <button
        type="button"
        v-if="copia._id && editando"
        class="boton boton--enviar"
        @click="guardar(copia)"/>
    </div>

    <ul class="tabs">
      <li class="tabs__tab"
      :class="{'tabs__tab--active': tabActual === 0}"
      @click="tabActual = 0">Bloque 1</li>
      <li class="tabs__tab"
      :class="{'tabs__tab--disabled': copia.bloqueActual < 1, 'tabs__tab--active': tabActual === 1}"
      @click="tabActual = 1">Bloque 2</li>
      <li class="tabs__tab"
      :class="{'tabs__tab--disabled': copia.bloqueActual < 2, 'tabs__tab--active': tabActual === 2}"
      @click="tabActual = 2">Bloque 3</li>
      <li class="tabs__tab"
      :class="{'tabs__tab--disabled': copia.bloqueActual < 3, 'tabs__tab--active': tabActual === 3}"
      @click="tabActual = 3">Bloque 4</li>
      <li class="tabs__tab"
      :class="{'tabs__tab--disabled': copia.bloqueActual < 4, 'tabs__tab--active': tabActual === 4}"
      @click="tabActual = 4">Bloque 5</li>
      <li class="tabs__tab"
      :class="{'tabs__tab--disabled': copia.bloqueActual < 5, 'tabs__tab--active': tabActual === 5}"
      @click="tabActual = 5">Bloque 6</li>
      <li class="tabs__tab"
      :class="{'tabs__tab--disabled': copia.bloqueActual < 6, 'tabs__tab--active': tabActual === 6}"
      @click="tabActual = 6">Bloque 7</li>
      <li class="tabs__tab"
      :class="{'tabs__tab--disabled': copia.bloqueActual < 7, 'tabs__tab--active': tabActual === 7}"
      @click="tabActual = 7">Bloque 8</li>
      <li class="tabs__tab"
      :class="{'tabs__tab--disabled': copia.bloqueActual < 8, 'tabs__tab--active': tabActual === 8}"
      @click="tabActual = 8">Bloque 9</li>
      <li class="tabs__tab"
      :class="{'tabs__tab--disabled': copia.bloqueActual < 9, 'tabs__tab--active': tabActual === 9}"
      @click="tabActual = 9">Adjuntos</li>
    </ul>

    <div tabs__content>
      <formulario-header
        v-if="tabActual === 0" ref="bloque1"
        :submitted="submitted" :form="copia" :editando="editando"/>
      <form-aves-bloque2
        v-if="tabActual === 1" ref="bloque2"
        :submitted="submitted" :form="copia" :editando="editando"/>
      <form-aves-bloque3
        v-if="tabActual === 2" ref="bloque3"
        :submitted="submitted" :form="copia.body" :editando="editando"/>
      <form-aves-bloque4
        v-if="tabActual === 3" ref="bloque4"
        :submitted="submitted" :form="copia.body" :editando="editando"/>
      <form-aves-bloque5
        v-if="tabActual === 4" ref="bloque5"
        :submitted="submitted" :form="copia.body" :editando="editando"/>
      <form-gps
        v-if="tabActual === 5" ref="bloque6"
        :submitted="submitted" :form="copia" :editando="editando"/>
      <form-aves-bloque7
        v-if="tabActual === 6" ref="bloque7"
        :submitted="submitted" :form="copia.body" :editando="editando"/>
      <formulario-final
        v-if="tabActual === 7" ref="bloque8"
        :submitted="submitted" :form="copia" :indice="42" :editando="editando"/>
      <form-costos
        v-if="tabActual === 8" ref="bloque9"
        :submitted="submitted" :form="copia.costos" :editando="editando"/>
      <form-fotos
        v-if="tabActual === 9" ref="bloque10"
        :submitted="submitted" :form="copia" :editando="editando"/>
    </div>
  </section>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import isEmpty from "lodash/isEmpty";
import FormularioHeader from "../comun/FormularioHeader.vue";
import FormAvesBloque2 from "./FormAvesBloque2.vue";
import FormAvesBloque3 from "./FormAvesBloque3.vue";
import FormAvesBloque4 from "./FormAvesBloque4.vue";
import FormAvesBloque5 from "./FormAvesBloque5.vue";
import FormFotos from "../comun/FormFotos.vue";
import FormGps from "../comun/FormGps.vue";
import FormAvesBloque7 from "./FormAvesBloque7.vue";
import FormularioFinal from "../comun/FormularioFinal.vue";
import FormCostos from "../comun/FormCostos.vue";
import formMixin from "../comun/formMixin.js";

export default {
  name: "FormularioAves",
  mixins: [formMixin],
  components: {
    FormularioHeader,
    FormAvesBloque2,
    FormAvesBloque3,
    FormAvesBloque4,
    FormAvesBloque5,
    FormFotos,
    FormGps,
    FormAvesBloque7,
    FormularioFinal,
    FormCostos,
  },
  computed: {
    formulario() {
      return this.$store.state.formulario.formulario;
    },
  },
  watch: {
    formulario: {
      handler(val) {
        if (isEmpty(val)) {
          const copiaInspector = cloneDeep(this.$store.state.usuario.usuario);
          this.copia = {
            inspector: copiaInspector,
            nomFuncionario: `${copiaInspector.nombre} ${copiaInspector.apellidos}`,
            cedFuncionario: copiaInspector.cedula,
            areaConservacion: copiaInspector.areaConservacion,
            body: {
              gallinero: {},
              tipoBarreras: [],
              tiposMamiferosMayFrec: [],
              animalesProblema: [],
              tiposAvesAtacadas: [],
              razonTipoDepredador: [],
              razonesDepredacion: [],
              condicionesPermiso: [],
            },
            tipoForm: "aves",
            estado: "borrador",
            ubicacion: {},
            bloqueActual: 0,
            pos: { coordinates: [], type: "Point" },
            registroFotografico: [],
            fotosPaisajeFinca: [],
            fotosAnimalComido: [],
            nomPersonaContacto: "",
            telPersonaContacto: "",
            funcionariosParticipantes: ["", "", ""],
            costos: {},
          };
        } else {
          this.copia = cloneDeep(val);
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>
